/* eslint-disable no-console */
const pushToDataLayer = (data) => {
  console.log(data);
  const { dataLayer } = window;
  if (dataLayer === null || data === null) return;
  dataLayer.push({ ecommerce: null });
  dataLayer.push(data);
};

const getEventData = url => (
  new Promise((resolve, reject) => {
    fetch(url, {
      method: 'POST',
      headers: {
        accept: 'application/json',
        'content-type': 'application/json',
      },
    })
      .then((response) => {
        if (response.ok) {
          response.json().then(resolve);
        } else {
          response.json().then(reject);
        }
      })
      .catch(console.error);
  })
);

const addPaymentInfo = () => {
  const url = '/ga/AddPaymentInfoFormatter';
  getEventData(url)
    .then(ecommerce => (
      pushToDataLayer({
        event: 'add_payment_info',
        ecommerce,
      })
    ));
};

const addShippingInfo = () => {
  const url = '/ga/AddShippingInfoFormatter';
  getEventData(url)
    .then(ecommerce => (
      pushToDataLayer({
        event: 'add_shipping_info',
        ecommerce,
      })
    ));
};

const checkout = () => {
  const url = '/ga/CheckoutFormatter';
  getEventData(url)
    .then(ecommerce => (
      pushToDataLayer({
        event: 'begin_checkout',
        ecommerce,
      })
    ));
};

const gaAddToCart = (code, type) => {
  const url = `/ga/AddToCartFormatter?code=${code}&type=${type}`;
  return new Promise((resolve, reject) => {
    fetch(url, {
      method: 'POST',
      headers: {
        accept: 'application/json',
        'content-type': 'application/json',
      },
    })
      .then((response) => {
        if (response.ok) {
          // Add to datalayer
          console.log(response);
          pushToDataLayer({
            event: 'add_to_cart',
            ecommerce: {},
          });
          response.json().then(resolve);
        } else {
          response.json().then(reject);
        }
      })
      .catch(console.error);
  });
};

const init = () => {
  // Add in catch for all checkout buttons
  document.addEventListener('click', (event) => {
    const { target } = event;
    const { href } = target;
    if (href) {
      if (href.indexOf('checkout') !== -1) {
        checkout();
      }
    }
  });
};

const purchase = () => {
  const url = '/ga/PurchaseFormatter';
  getEventData(url)
    .then(ecommerce => (
      pushToDataLayer({
        event: 'purchase',
        ecommerce,
      })
    ));
};

const viewCart = () => {
  const url = '/ga/ViewCartFormatter';
  getEventData(url)
    .then(ecommerce => (
      pushToDataLayer({
        event: 'view_cart',
        ecommerce,
      })
    ));
};

const viewItem = (code, type) => {
  const url = `/ga/ViewItemFormatter?code=${code}&type=${type}`;
  getEventData(url)
    .then(ecommerce => (
      pushToDataLayer({
        event: 'view_item',
        ecommerce,
      })
    ));
};

const viewItemList = (category) => {
  const url = `/ga/ViewItemListFormatter?name=${category}`;
  getEventData(url)
    .then((ecommerce) => {
      if (ecommerce === null) return;
      pushToDataLayer({
        event: 'view_item_list',
        ecommerce,
      });
    });
};

export {
  addPaymentInfo,
  addShippingInfo,
  checkout,
  gaAddToCart,
  init,
  purchase,
  pushToDataLayer,
  viewCart,
  viewItem,
  viewItemList,
};
/* eslint-enable no-console */
